import axios from "axios";
import swal from "sweetalert";

const axiosInstance = axios.create({
  baseURL: "https://neelrupareliya.com/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem("authToken");  // Get the latest token
    if (authToken) {
      config.headers.Authorization = `${authToken}`;  // Add token to headers dynamically
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    try {
      if (response.data.status === false) {
        swal({
          title: response.data.message,
          icon: "error",
          className: "custom-swal",
        });
      }
      return response;
    } catch (error) {
      console.error("Response Handling Error:", error);
      return Promise.reject(error);
    }
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("authToken");
      window.location.href = "/admin"; // Redirect to login page
    }

    console.error("Response Error:", error.response ? error.response.status : error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
